var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14937 0.854985C6.95437 0.659985 6.63937 0.659985 6.44437 0.854985L3.99938 3.29499L1.55438 0.849985C1.35938 0.654985 1.04438 0.654985 0.849375 0.849985C0.654375 1.04499 0.654375 1.35999 0.849375 1.55499L3.29438 3.99999L0.849375 6.44498C0.654375 6.63999 0.654375 6.95498 0.849375 7.14998C1.04438 7.34499 1.35938 7.34499 1.55438 7.14998L3.99938 4.70499L6.44437 7.14998C6.63937 7.34499 6.95437 7.34499 7.14937 7.14998C7.34437 6.95498 7.34437 6.63999 7.14937 6.44498L4.70437 3.99999L7.14937 1.55499C7.33937 1.36499 7.33937 1.04499 7.14937 0.854985Z",
    fill: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearGreen);
export default __webpack_public_path__ + "static/media/clear-green.35eafad1283161d33ac3835df8fe39d7.svg";
export { ForwardRef as ReactComponent };